<svg
	aria-hidden="true"
	viewBox="0 0 20 20"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M10 1.75L12.4108 3.21104L15.1758 2.98684L16.2493 5.54555L18.4544 7.23155L17.6844 9.89621L18.4544 12.5609L16.2493 14.2469L15.1758 16.8056L12.4108 16.5814L10 18.0424L7.58917 16.5814L4.82422 16.8056L3.75073 14.2469L1.54564 12.5609L2.31557 9.89621L1.54564 7.23155L3.75073 5.54555L4.82422 2.98684L7.58917 3.21104L10 1.75Z"
		fill="currentColor"
	/>
	<path
		d="M6.25 9.89624L8.6875 12.3337L13.75 7.27124"
		stroke="white"
		stroke-width="1.8"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
